import {VTabs, VTab, VBtn, VTabsItems, VTabItem} from 'vuetify/lib'
import Header from '../components/Header.jsx'
import FundSecurity from '../components/FundSecurity.jsx'
import General from './components/General.jsx'
import CapitalGains from '../components/CapitalGains.jsx'
import { go_target_key_all } from '../constants'
import styles from '../index.module.less'
import ContainMixIns from '../ContainMixIns'
import {groupFinanceBalanceMonthlyLedgerApi} from '../service'
const list = [
    {
        title: '集团资金概况',
        Component: General
    },
    {
        title: '集团资金安全情况',
        Component: FundSecurity
    },
    {
        title: '集团资金收益情况',
        Component: CapitalGains
    }
]
export default {
    mixins: [ContainMixIns],
    data() {
        return {
            takeEffectLoading: false,
            // tab: 0,
            // header: [],
            // canEdit: false,
            // params: {
            //     unit: 1,
            //     begin_month: moment().subtract(1, 'months').format('YYYY-MM'),
            //     end_month: moment().subtract(1, 'months').format('YYYY-MM'),
            //     month: moment().subtract(1, 'months').format('YYYY-MM'),
            // }
        }
    },
    created() {
       let params = localStorage.getItem(go_target_key_all)
        if (params) {
            localStorage.removeItem(go_target_key_all)
            params = JSON.parse(params)
            if (params instanceof Object) {
                Object.keys(this.params).forEach(key => {
                    params[key] = params[key] || this.params[key]
                })
                this.params = params
            }
        }
        this.$nextTick(() => {
            this.changeHeader()
        })
    },
    // mounted() {
    //     this.changeTable()
    // },
    methods: {
        takeEffect() {
            this.takeEffectLoading = true
            groupFinanceBalanceMonthlyLedgerApi({month:this.params.month}).then(() => {
                this.$Message.success('成功生效！')
            }).finally(() => {
                this.takeEffectLoading = false
            })
        }
    },
    // methods: {
    //     changeTable(index = this.tab) {
    //         this.$nextTick(() => {
    //             this.$refs[index] && this.$refs[index].getDataProxy && this.$refs[index].getDataProxy()
    //         })
    //     },
    //     changeHeader(_, is_change_date) {
    //         const res = []
    //         const f = this.header[0]
    //         const l = this.header[this.header.length - 1]
    //         let begin_month = this.params.begin_month 
    //         const end_month = this.params.end_month 
    //         // 当值没有发生变化时不更新table的头部
    //        if (f && l && f.key === begin_month && l.key === end_month) {
    //         return 
    //        }
    //         while (begin_month <= end_month) {
    //             res.push(begin_month)
    //             begin_month = moment(begin_month).add(1, 'month').format('YYYY-MM')
    //         }
    //         this.header = res
    //        if (is_change_date) {
    //          this.changeTable()
    //        }
    //     }
    // },
    render() {
        const _this = this
        return <div>
            <Header 
                v-model={_this.params}
                showSynButton
                isDateNode={_this.tab === 0}
                isRange={_this.tab !== 0}
                disabledRadio={_this.canEdit}
                on={{
                    change: _this.changeHeader
                }}
            />
             <div class={styles['df']}>
                <div class={styles['df-1']}>
                    <VTabs v-model={_this.tab} on={{change:(val) => {
                        _this.changeTable(val)
                    }}}>
                        {list.map(item => <VTab>{item.title}</VTab>)}
                    </VTabs>
                </div>
                {_this.tab === 0 && <div style="margin:8px 0" >
                    <VBtn color="primary" loading={_this.takeEffectLoading} on={{
                        click: _this.takeEffect
                    }}>
                       生效
                    </VBtn>
                </div>}
                {_this.tab === 1 && <div style="margin:8px 0" >
                    <VBtn color="primary" on={{
                        click: () => {
                            if (!_this.canEdit) {
                                _this.canEdit = true
                                _this.params.unit = 1
                                _this.editFunProxy()
                            } else {
                                _this.saveChildProxy()
                            }
                        }
                    }}>
                        {_this.canEdit ? '生效' : '编辑'}
                    </VBtn>
                   { _this.canEdit && <VBtn style="margin-left:8px" on={{
                        click: () => {
                            _this.canEdit = false
                        }
                    }}>
                       取消
                    </VBtn>}
                </div>}
            </div>
            <VTabsItems v-model={_this.tab}>
                {list.map((item, index) => {
                    const Component = item.Component
                    const header = _this.header
                    return <VTabItem key={index}flat>
                    <Component
                        header={header}
                        ref={index}
                        params={_this.params}
                        canEdit={_this.canEdit}
                        on={{
                            go:() => {
                               localStorage.setItem(go_target_key_all, JSON.stringify(this.params))
                            },
                            success:() => {
                                if (_this.tab === 1) {
                                    _this.changeTable()
                                }
                            }
                        }}
                    />
                </VTabItem>
                })}
            </VTabsItems>
        </div>
    }
}